import { ControlledTextInput } from '@components/ControlledTextInput';
import { FiltersModal } from '@components/FiltersModal/FiltersModal';
import { useGeoDataContext } from '@contexts/GeoDataContext';
import { Checkbox, SelectInput } from '@gurupay/gp-ui-library';
import { useClearFilter } from '@hooks/useClearFilter';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AccountStatus } from 'types/operations';

export interface AccountFilters {
	iban?: string;
	name?: string;
	currency?: string;
	status?: AccountStatus[];
}

export const ALL_ACCOUNT_FILTER_STATUSES = [
	AccountStatus.OPENED,
	AccountStatus.CLOSED,
	AccountStatus.BLOCKED,
];

const statusCheckboxes = [
	{ value: AccountStatus.OPENED, label: 'accounts.filters.status.opened' },
	{ value: AccountStatus.CLOSED, label: 'accounts.filters.status.closed' },
	{ value: AccountStatus.BLOCKED, label: 'accounts.filters.status.blocked' },
];

interface AccountFilterProps {
	onApply: (filters: AccountFilters) => void;
}

export const AccountFilter = ({ onApply }: AccountFilterProps) => {
	const { t } = useTranslation();
	const filterForm = useFormContext<AccountFilters>();
	const { handleSubmit, control } = filterForm;
	const { hasFilters, handleClear } = useClearFilter(filterForm, onApply);
	const geoData = useGeoDataContext();

	return (
		<FiltersModal
			hasFilters={hasFilters}
			onClear={handleClear}
			onSubmit={handleSubmit(onApply)}
		>
			<ControlledTextInput label={t('filters.byIban')} name="iban" />
			<ControlledTextInput label={t('filters.byName')} name="name" />

			<Controller
				control={control}
				name="currency"
				render={({ field }) => (
					<SelectInput
						{...field}
						className="max-w-125"
						label={t('filters.byCurrency')}
						options={geoData?.data?.currencies ?? []}
						showClear
					/>
				)}
			/>

			<Controller
				control={control}
				name="status"
				render={({ field }) => {
					const { onChange, value = [] } = field;

					return (
						<div className="flex flex-wrap gap-space-16 max-mobile:mx-[-8px]">
							{statusCheckboxes.map((item) => (
								<Checkbox
									key={item.value}
									checked={value.includes(item.value)}
									label={t(item.label)}
									onChange={(checked: boolean) => {
										onChange(
											checked
												? [...value, item.value]
												: value.filter((v) => v !== item.value),
										);
									}}
								/>
							))}
						</div>
					);
				}}
			/>
		</FiltersModal>
	);
};
